export const translations = {
  en: {
    // Navigation
    nav: {
      about: "About",
      skills: "Skills",
      projects: "Projects",
      education: "Education",
      contact: "Contact",
      tools: "Tools",
      featured: "Featured",
      otherProjects: "Projects",
      contributions: "Contributions",
      openMenu: "Open section menu",
      closeMenu: "Close section menu"
    },
    
    // Hero Section
    hero: {
      greeting: "Hi, I'm",
      name: "Milorad Maksić",
      title: "Software Engineer & Master's Student",
      subtitle: "Building scalable solutions with modern technologies",
      cta: "View My Work",
      contact: "Get In Touch"
    },
    
    // About Section
    about: {
      title: "About Me",
      // PLACEHOLDER - Edit this text with your bio
      bio: `I'm a passionate software engineer currently pursuing my Master's degree in Applied Software Engineering at the Faculty of Technical Sciences in Novi Sad, Serbia. 
      
      With expertise in backend development and full-stack capabilities, I specialize in building scalable microservices architectures, cloud-native applications, and machine learning solutions.
      
      Currently exploring cybersecurity and planning to deepen my knowledge in JavaScript/TypeScript. I love solving complex problems and turning ideas into reality through code.`,
      location: "Novi Sad, Serbia",
      education: "Master's in Applied Software Engineering",
      status: "Open to opportunities",
      interests: "Interests",
      interestsList: [
        "Cybersecurity",
        "Backend Development", 
        "Chess",
        "Sports"
      ]
    },
    
    // Skills Section
    skills: {
      title: "Tech Stack",
      subtitle: "Technologies I work with",
      categories: {
        languages: "Languages",
        backend: "Backend",
        frontend: "Frontend",
        databases: "Databases",
        cloud: "Cloud & DevOps",
        tools: "Tools"
      }
    },
    
    // Open-Source Tools Section
    tools: {
      title: "Open-Source Tools",
      subtitle: "Released tools with real users"
    },

    // Open-Source Contributions Section
    contributions: {
      title: "Open-Source Contributions",
      subtitle: "Pull requests to other people's projects",
      details: "Write-up",
      viewRepo: "All contributions on GitHub",
      statuses: {
        merged: "Merged",
        open: "Open",
        closed: "Closed"
      }
    },

    // Projects Section
    projects: {
      title: "Projects",
      subtitle: "Things I've built",
      featured: "Featured",
      all: "All Projects",
      filter: "Filter by technology",
      search: "Search projects...",
      viewCode: "View Code",
      viewDemo: "Live Demo",
      readMore: "Read More",
      close: "Close",
      highlights: "Highlights",
      technologies: "Technologies Used"
    },
    
    // Education Section
    education: {
      title: "Education",
      institution: "Faculty of Technical Sciences, Novi Sad",
      degree: "Master's Degree",
      field: "Applied Software Engineering",
      status: "Currently Pursuing",
      bachelor: "Bachelor's Degree in Applied Software Engineering",
      bachelorStatus: "Completed"
    },
    
    // Contact Section
    contact: {
      title: "Get In Touch",
      // subtitle: "Let's build something together",
      email: "Email",
      linkedin: "LinkedIn",
      github: "GitHub",
      // instagram: "Instagram",
      downloadCV: "Download CV",
      copyEmail: "Copy Email",
      emailCopied: "Email copied!"
    },
    
    // Footer
    footer: {
      rights: "All rights reserved",
      madeWith: "Made with",
      and: "and",
      by: "by"
    },
    
    // Common
    common: {
      loading: "Loading...",
      error: "Something went wrong",
      noResults: "No results found",
      tryAgain: "Try again"
    }
  },
  
  sr: {
    // Navigacija
    nav: {
      about: "O meni",
      skills: "Veštine",
      projects: "Projekti",
      education: "Obrazovanje",
      contact: "Kontakt",
      tools: "Alati",
      featured: "Istaknuto",
      otherProjects: "Projekti",
      contributions: "Doprinosi",
      openMenu: "Otvori meni sekcija",
      closeMenu: "Zatvori meni sekcija"
    },
    
    // Hero sekcija
    hero: {
      greeting: "Zdravo, ja sam",
      name: "Milorad Maksić",
      title: "Softverski Inženjer & Master Student",
      subtitle: "Gradim skalabilna rešenja sa modernim tehnologijama",
      cta: "Pogledaj rad",
      contact: "Stupi u kontakt"
    },
    
    // O meni sekcija
    about: {
      title: "O Meni",
      // PLACEHOLDER - Izmeni ovaj tekst sa svojom biografijom
      bio: `Strastveni sam softverski inženjer koji trenutno pohađa master studije Primenjenog softverskog inženjerstva na Fakultetu tehničkih nauka u Novom Sadu, Srbija.
      
      Sa ekspertizom u backend razvoju i full-stack sposobnostima, specijalizujem se za izgradnju skalabilnih mikroservisnih arhitektura, cloud-native aplikacija i machine learning rešenja.
      
      Trenutno istražujem sajber bezbednost i planiram da produbim svoje znanje u JavaScript/TypeScript tehnologijama. Volim da rješavam složene probleme i pretvaraam ideje u realnost kroz kod.`,
      location: "Novi Sad, Srbija",
      education: "Master Primenjenog softverskog inženjerstva",
      status: "Otvoren za prilike",
      interests: "Interesovanja",
      interestsList: [
        "Sajber bezbednost",
        "Backend razvoj",
        "Sah",
        "Sportovi"
      ]
    },
    
    // Veštine sekcija
    skills: {
      title: "Tehnologije",
      subtitle: "Tehnologije sa kojima radim",
      categories: {
        languages: "Jezici",
        backend: "Backend",
        frontend: "Frontend",
        databases: "Baze podataka",
        cloud: "Cloud & DevOps",
        tools: "Alati"
      }
    },
    
    // Open-source alati sekcija
    tools: {
      title: "Open-Source Alati",
      subtitle: "Objavljeni alati koje ljudi koriste"
    },

    // Open-source doprinosi sekcija
    contributions: {
      title: "Open-Source Doprinosi",
      subtitle: "Pull request-ovi na tuđim projektima",
      details: "Detalji",
      viewRepo: "Svi doprinosi na GitHub-u",
      statuses: {
        merged: "Spojeno",
        open: "Otvoreno",
        closed: "Zatvoreno"
      }
    },

    // Projekti sekcija
    projects: {
      title: "Projekti",
      subtitle: "Stvari koje sam napravio",
      featured: "Istaknuto",
      all: "Svi projekti",
      filter: "Filtriraj po tehnologiji",
      search: "Pretraži projekte...",
      viewCode: "Pogledaj kod",
      viewDemo: "Demo",
      readMore: "Pročitaj više",
      close: "Zatvori",
      highlights: "Karakteristike",
      technologies: "Korišćene tehnologije"
    },
    
    // Obrazovanje sekcija
    education: {
      title: "Obrazovanje",
      institution: "Fakultet tehničkih nauka, Novi Sad",
      degree: "Master studije",
      field: "Primenjeno softversko inženjerstvo",
      status: "U toku",
      bachelor: "Osnovne studije Primenjenog softverskog inženjerstva",
      bachelorStatus: "Završeno"
    },
    
    // Kontakt sekcija
    contact: {
      title: "Stupi u kontakt",
      // subtitle: "Hajde da napravimo nešto zajedno",
      email: "Email",
      linkedin: "LinkedIn",
      github: "GitHub",
      // instagram: "Instagram",
      downloadCV: "Preuzmi CV",
      copyEmail: "Kopiraj email",
      emailCopied: "Email kopiran!"
    },
    
    // Footer
    footer: {
      rights: "Sva prava zadržana",
      madeWith: "Napravljeno sa",
      and: "i",
      by: "od strane"
    },
    
    // Opšte
    common: {
      loading: "Učitavanje...",
      error: "Nešto nije u redu",
      noResults: "Nema rezultata",
      tryAgain: "Pokušaj ponovo"
    }
  }
};

export default translations;
